export default __webpack_public_path__ + "static/media/pic9.35695812.jpg";